import React from 'react';
import HeroSection from '../Components/home/HeroSection.jsx';
import BrandStrip from '../Components/home/BrandStrip.jsx';
import SectorsSection from '../Components/home/SectorsSection.jsx';
import AboutSection from '../Components/home/AboutSection.jsx';
import CTASection from '../Components/home/CTASection.jsx';


export default function Home() {
    return (
        <div className="min-h-screen">
            <HeroSection />
            <BrandStrip />
            <SectorsSection />
            <AboutSection />
            <CTASection />
        </div>
    );
}